import { render, staticRenderFns } from "./DeliveryLocationsCard.vue?vue&type=template&id=2679cd4c&scoped=true"
import script from "./DeliveryLocationsCard.vue?vue&type=script&lang=js"
export * from "./DeliveryLocationsCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryLocationsCard.vue?vue&type=style&index=0&id=2679cd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679cd4c",
  null
  
)

export default component.exports